const API_BASE_URL = process.env.REACT_APP_DJANGO_APP_URL;

// Regular GET requests that return JSON
export const getBackend = async (endpoint, { params = {} } = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `${API_BASE_URL}/${endpoint}${
    queryString ? `?${queryString}` : ""
  }`;

  try {
    const response = await fetch(url);
    if (!response.ok) {
      const error = await response.json();
      console.error("Error response:", error);
      alert(Object.entries(error).map((entry, index) => {
        const value = entry[1][0];
        return `${index + 1}. ${value}\n`;
      }).join(''));
      return null;
    }
    return response.json();
  } catch (error) {
    console.error("Error fetching data from backend:", error);
    throw error;
  }
};

// Specifically for file downloads
export const getFileBackend = async (endpoint, { params = {} } = {}) => {
  const queryString = new URLSearchParams(params).toString();
  const url = `${API_BASE_URL}/${endpoint}${
    queryString ? `?${queryString}` : ""
  }`;

  try {
    const response = await fetch(url);

    if (!response.ok) {
      const error = await response.json();
      console.error("Error response:", error);
      alert(Object.entries(error).map((entry, index) => {
        const value = entry[1][0];
        return `${index + 1}. ${value}\n`;
      }).join(''));
      return null;
    }
    return response;
  } catch (error) {
    console.error("Error fetching file from backend:", error);
    throw error;
  }
};

export const postBackend = async (endpoint, data, isFormData = false) => {
  let options = {
      method: 'POST',
      headers: {},
      body: null,
  };
  if (isFormData) {
      options.body = data; // FormData, do not stringify
  } else {
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(data);
  }

  try {
      const response = await fetch(`${API_BASE_URL}/${endpoint}/`, options);
      if (!response.ok) {
          const error = await response.json();
          console.error("Error response:", error);
          alert(Object.entries(error).map(([field, messages], index) => {
            const formattedMessages = Array.isArray(messages) ? messages.join(', ') : messages;
            return `${index + 1}. ${field}: ${formattedMessages}`;
          }).join('\n'));
          return null;
      }
      return response.json();
  } catch (error) {
      console.error("Fetch error:", error);
      alert(error);
      return null;
  }
};

export const putBackend = async (endpoint, data) => {
    const response = await fetch(`${API_BASE_URL}/${endpoint}/${data.uuid}/`, {
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(data)
    });
    if (response.status >= 300) {
        alert(Object.entries(await response.json()).map((entry, index) => {
          const value = entry[1][0];
          return `${index + 1}. ${value}\n`;
        }).join(''))
        return
    }
    return response.json();
};

export const deleteBackend = async (endpoint, id = "", body = {}) => {
    const response = await fetch(`${API_BASE_URL}/${endpoint}/` + id, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    });
    if (response.status >= 300) {
      const error = await response.json();
      console.error("Error response:", error);
      alert(Object.entries(error).map((entry, index) => {
        const value = entry[1][0];
        return `${index + 1}. ${value}\n`;
      }).join(''))
      return null
    }
};

export const deleteBackendBulk = async (endpoint, uuids) => {
    const response = await fetch(`${API_BASE_URL}/${endpoint}/bulk_delete/`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uuids })
    });
    if (response.status >= 300) {
        alert(response.content)
        return
    }
};

export const uploadImage = async (endpoint, imageFile) => {
  const formData = new FormData();
  formData.append("image", imageFile);

  const response = await fetch(`${API_BASE_URL}/${endpoint}/`, {
    method: "POST",
    body: formData,
  });

  if (response.status >= 300) {
    const errorData = await response.json();
    alert(JSON.stringify(errorData));
    throw new Error("Image upload failed");
  }

  return response.json();
};

export const getImage = async (imagePath) => {
  const response = await fetch(`${API_BASE_URL}${imagePath}`);

  if (response.status >= 300) {
    alert("Failed to fetch image");
    throw new Error("Image fetch failed");
  }

  const blob = await response.blob();
  const imageUrl = URL.createObjectURL(blob);
  return imageUrl;
};

const getAuthHeaders = () => {
  const token = localStorage.getItem("access_token");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

export const loginUser = async (endpoint, credentials) => {

  const response = await fetch(`${API_BASE_URL}/${endpoint}/`, {
    headers: {'Content-Type': 'application/json'},
    method: "POST",
    body: JSON.stringify(credentials),
  });

  const data = await response.json();

  if (response.status === 401) {
    return null;
  }

  localStorage.setItem("access_token", data.access);
  localStorage.setItem("refresh_token", data.refresh);
  return data;
};

export const getUserData = async (endpoint) => {
  const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
    headers: getAuthHeaders(),
  });

  if (!response.ok) {
    if (response.status === 401) {
      alert("Su sesión caducó. Por favor autentiquese nuevamente");
    } else {
      const errorData = await response.json();
      alert(JSON.stringify(errorData));
    }
    return null;
  }

  return response.json();
};

export const logoutUser = () => {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
};
